'use strict';
(function () {
    App.directive('addressForm', addressFormDirective);
    addressFormDirective.$inject = ['Config'];


    function addressFormDirective(Config) {
        return {
            restrict: 'E',
            templateUrl: Config.TEMPLATES_DIR + 'Components/address-form.html',
            controllerAs: 'af',
            bindToController: true,
            scope: {
                form: '=',
                model: '=',
                prefix: '<',
                hidePost: '<?',
                country: '<?',
            },
            controller: AddressFormController,
        }
    }

    AddressFormController.$inject = ['$scope', 'statesService', '$q', '$filter'];

    function AddressFormController($scope, statesService, $q, $filter) {
        let self = this;

        self.$onInit = function () {
            self.hidePost = self.hidePost || false;
            self.country = self.country || 'POLISH';
            if (self.model) {
                self.zipCodeViewValue = self.model.zipCode;
                if (self.zipCodeViewValue) {
                    let deferred = $q.defer();
                    populateAddressHintsFromServer(deferred, self.model.city);
                    deferred.promise.then(function (r) {
                        console.log(r);
                    });
                }
            }
        };

        self.citySearchText = '';
        self.searchTextStreet = '';

        self.cityHints = [];
        self.streetHints = [];

        self.zipCodeViewValue = null;

        function populateAddressHintsFromServer(deferred, selectedCity) {
            statesService.dataCitybyZipCodeLists({zipCode: self.zipCodeViewValue})
                .then(function (success) {
                    if (success.data) {
                        var mapped = $filter('addressRecognition')(success.data);
                        self.cityHints = mapped;
                        if (selectedCity) {
                            let hintsLength = self.cityHints ? self.cityHints.length : 0;
                            for (let i = 0; i < hintsLength; i++) {
                                if (self.cityHints[i].city === selectedCity) {
                                    self.streetHints = self.cityHints[i].streets;
                                }
                                break;
                            }
                        } else if (self.country !== 'OTHER' && self.cityHints.length === 1) {
                            self.model.city = self.cityHints[0].city;
                            if (self.cityHints[0].streets.length === 1) {
                                self.model.street = self.cityHints[0].streets[0];
                            }
                        }
                        deferred.resolve(mapped.map(function (item) {
                            return item.city
                        }));
                    }
                });
        }

        self.zipCodeCallback = function (event) {
            self.zipCodeViewValue = event.$viewValue;
            self.model.city = '';
            self.model.street = '';
            self.model.number = '';
            self.model.apartment = '';
            self.model.post = '';
            self.cityHints = [];
            self.streetHints = [];
        };

        /**
         * Fetches locations for autocomplete input;
         * @param query
         */
        self.querySearchCity = function (query) {
            console.log('querySearchLocalization "' + query + '"')
            let deferred = $q.defer();
            if (self.zipCodeViewValue) {
                if (self.cityHints.length > 0) {
                    let filtered = _.filter(self.cityHints, hint => !query || (hint.city.toLowerCase()).indexOf(query.toLowerCase()) > -1)
                    deferred.resolve(_.map(filtered, 'city'));
                } else {
                    populateAddressHintsFromServer(deferred);
                }
            } else {
                deferred.resolve([]);
            }
            return deferred.promise;
        };

        self.onCitySearchTextChange = function (text) {
            console.log('onCitySearchTextChange "' + text + '"')
            if (!text) {
                self.citySearchText = '';
            }
            self.searchTextStreet = '';
            self.model.street = '';
            self.model.number = '';
            self.model.apartment = '';
            self.model.post = '';
        };

        self.selectedCityChanged = function (city) {
            console.log(`selectedCityChanged "` + city + '"')
            if (!self.model) {
                return 0;
            }
            self.model.street = '';
            self.model.number = '';
            self.model.apartment = '';
            self.model.post = ''
            let hintsLength = self.cityHints ? self.cityHints.length : 0;
            for (let i = 0; i < hintsLength; i++) {
                if (self.cityHints[i].city === city) {
                    self.streetHints = self.cityHints[i].streets;
                    if (self.country !== 'OTHER' && self.streetHints.length === 1) {
                        self.model.street = self.streetHints[0];
                    }
                    break;
                }
            }
        };

        self.cityBlur = function () {
            self.model.city = self.citySearchText;
        }

        self.cityKeyPress = function(event) {
            if(event.which === 13) {
                event.preventDefault();
                self.cityBlur();
            }
        }

        self.querySearchStreet = function (query, hints) {
            return getResults(query, hints)
                .then(function (results) {
                    return results;
                });

            function getResults(query, hints) {
                var deferred = $q.defer();

                if (hints) {
                    if (!query || !query.length) {
                        deferred.resolve(hints)
                    } else {
                        var filtered = hints.filter(function (hint) {
                            if (!query) return true;
                            return (hint.toLowerCase()).indexOf(query.toLowerCase()) > -1;
                        });
                        deferred.resolve(filtered);
                    }
                } else {
                    deferred.resolve([]);
                }

                return deferred.promise;
            }
        };


        self.streetBlur = function () {
            self.model.street = self.searchTextStreet;
        }

        self.streetKeyPress = function(event) {
            if(event.which === 13) {
                event.preventDefault();
                self.streetBlur();
            }
        }
    }
})();
